<template>
  <div>
    <PageHeader page-name="SEO шаблоны Тематическая страница + Город">
      <template>
        <router-link :to="{name: 'CreateSeoTopicTemplate'}">
          <el-button type="primary">
            Создать SEO шаблон
          </el-button>
        </router-link>
      </template>
    </PageHeader>
    <MainPanel>
      <List v-loading="loading" />
    </MainPanel>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import List from '@/components/seo-templates-topic/List'
import MainPanel from '@/components/common/MainPanel'
import PageHeader from '@/components/common/PageHeader';

export default {
  name: 'SeoTemplatesTopicListPage',
  components: {MainPanel, List, PageHeader},
  metaInfo: {
    title: 'SEO шаблоны Тематическая страница + Город',
  },
  data() {
    return {
      loading: false,
    }
  },
  async mounted() {
    this.loading = true
    await this.getModel()
    this.loading = false
  },
  methods: {
    ...mapActions('seoTemplatesTopic', {
      getModel: 'fetchSeoTemplatesList',
    }),
  },
}
</script>

<style lang="sass" scoped>
.seo-templates-list
  padding: 20px

.seo-templates-list__header
  display: flex
  justify-content: space-between
  align-items: center
  margin-bottom: 20px

.seo-templates-list__title
  margin: 0
  font-size: 24px
  font-weight: 500

.seo-templates-list__table
  margin-top: 20px

.seo-templates-list__image
  max-width: 50px
  max-height: 50px
  object-fit: contain
</style>


